import toast from "react-hot-toast";
import useRead from "../useRead";
import { debounce } from "lodash";

const useSelectTemplateForUserSalary = () => {
  const { list, setGetListParams, paramsObject } = useRead({
    url: "template-salary-structure/list",
    initialData: {
      pageNo: 0,
      limit: 12,
      search: "",
    },
    method: "GET",
    onError: (error) => {
      toast.error("Error fetching salary templates: " + error.message);
    },
  });
  const isTemplateListLoading = list.isLoading;
  const templatesList = list.data?.salary_structure_data || [];
  const pagination = list.data?.pagination || {};

  const handlePageClick = (page) => {
    setGetListParams({ ...paramsObject, pageNo: page.selected });
  };

  const handleSearch = debounce((e) => {
    setGetListParams({ ...paramsObject, search: e.target.value, pageNo: 0 });
  }, 750);

  return {
    templatesList,
    pagination,
    isTemplateListLoading,
    handlePageClick,
    handleSearch,
  };
};

export default useSelectTemplateForUserSalary;
